import { render, staticRenderFns } from "./stk_poin.vue?vue&type=template&id=eafad04c&scoped=true"
import script from "./stk_poin.vue?vue&type=script&lang=js"
export * from "./stk_poin.vue?vue&type=script&lang=js"
import style0 from "./stk_poin.vue?vue&type=style&index=0&id=eafad04c&prod&scoped=true&lang=less"
import style1 from "./stk_poin.vue?vue&type=style&index=1&id=eafad04c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafad04c",
  null
  
)

export default component.exports